import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').IconMarker}
 */

const IconMarker = ({ lat, lng }) => {
    return (
        <div
            className='h-[30px] w-[30px] bg-brand-500 rounded-full'
            style={{
                position: 'absolute',
                transform: 'translate(-50%, -100%)',
                cursor: 'pointer',
            }}/>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconMarker;
